<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('modification.assignchangeagent.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('modification.title') }} > </span>
            <span class="middle_loc">{{ $t('modification.assignchangeagent.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01">
              <h2>{{ $t('modification.assignchangeagent.fields.step_01') }}</h2>
              <p>{{ $t('modification.assignchangeagent.fields.search_application') }}</p>
            </v-flex>
            <v-flex class="step_box step02">
              <h2>{{ $t('modification.assignchangeagent.fields.step_02') }}</h2>
              <p>{{ $t('modification.assignchangeagent.fields.select_service') }}</p>
            </v-flex>
            <v-flex class="step_box step03 active">
              <h2>{{ $t('modification.assignchangeagent.fields.step_03') }}</h2>
              <p>{{ $t('modification.assignchangeagent.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step04">
              <h2>{{ $t('modification.assignchangeagent.fields.step_04') }}</h2>
              <p>{{ $t('modification.assignchangeagent.fields.review_submit') }}</p>
            </v-flex>
          </v-layout>

          <v-layout class="inner_contents mt-30" column>
            <ApplicationInformation2 :receipt_no="receipt_no" />

            <h2 class="m_title mt-45">{{ $t('modification.assignchangeagent.fields.request_type') }}</h2>
            <div class="input_checkbox_type_basic radio_dailog_type row ma-0 pt--10 pl-15 pr-15">
              <v-radio-group
                row
                v-model="assign_request_type_code"
              >
                <template v-for="(code, i) in $vuetify.rtl ? typeCodeListAr : typeCodeListEn">
                  <v-radio
                    color="#a01c2a"
                    :key="code.value"
                    :label="code.text"
                    :value="code.value"
                    disabled
                    readonly
                    class="view__radio"
                  >
                  </v-radio>
                  <v-spacer class="hidden_lr10" :key="i" ></v-spacer>
                </template>
              </v-radio-group>
            </div>

            <div class="my_app_tabs_data mt-25">
              <v-flex>
                <h3 class="sub_title_box">
                  {{ $t('modification.assignchangeagent.fields.representative') }}
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="representativeNewable && representatives.length === 0"
                    color="#333"
                    dark
                    outlined
                    height="25"
                    class="btn-normal ft-size11"
                    @click="fnSetMyAgentInformation()"
                  >
                    {{ $t('modification.assignchangeagent.fields.get_my_agent_information') }}
                  </v-btn>
                  <v-spacer class="hidden_lr8"></v-spacer>
                </h3>
                <Representative
                  :receipt_no.sync="receipt_no"
                  :assign_request_type_code.sync="assign_request_type_code"
                  :isNewable="representativeNewable"
                  :isEditable="representativeEditable"
                  :isRemovable="representativeRemovable"
                  v-if="flag_representative"
                  ref="component_representative"
                  @loadRepresentatives="fnGetRepresentatives"
                />
              </v-flex>
            </div>
          </v-layout>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-btn
                dense
                dark
                color="#acb0b3"
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoBefore()"
              >{{ $t('common.button.before') }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                dark
                @click="fnGoNextStep()"
              >{{ $t('common.button.next') }}</v-btn>
            </v-col>
          </v-row>

        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import Representative from './AssignChangeAgentRepresentative'
import ApplicationInformation2 from '@/components/layout/ApplicationInformation2'
//assign용 representative 컴포넌트 만든 후 여기에 붙인다

export default {
  name: 'AssignChangeAgentStep3',
  components :{
    Representative,
    ApplicationInformation2
  },
  data() {
    return {
      receipt_no : this.$route.params.receipt_no,
      auto_insert_representative : false,
      flag_representative : false,

      assign_request_type_code : '',

      representativeNewable: false,
      representativeEditable: false,
      representativeRemovable: false,

      representatives: [],

      typeCodeListAr : [],
      typeCodeListEn: [],
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetAssignChangeAgentInfo()
    this.fnGetTypecode()
  },
  methods: {
    fnGetTypecode(){
      let options = {
        upper_code: '5610'
      }
      utils.fnGetCodeList(options).then(list => {
        this.typeCodeListAr = list.ar
        this.typeCodeListEn = list.en
      })
    },
    fnGetRepresentatives(representatives) {
      this.representatives = representatives
    },
    fnSetMyAgentInformation() {
      requestApi({
        url: '/receivings/assign/agent/'+ this.receipt_no +'/representative/my',
        method: 'POST',
        callback: (res) => {
          if(res.res_code === '200'){
            this.$refs.component_representative.fnGetRepresentatives()
          } else {
             if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSetMyAgentInformation()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetAssignChangeAgentInfo(){
      requestApi({
        url: '/receivings/'+this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if(res.res_code === '200'){
            this.assign_request_type_code = res.data.assign_request_type_code

            if(this.assign_request_type_code == '5611'){
              //요청 구분이 Assign Agent 이라면
              this.representativeNewable = true
              this.representativeEditable = false
              this.representativeRemovable = false

            }else if(this.assign_request_type_code == '5612'){
              //요청 구분이 Change Agent 이라면
              this.representativeNewable = false
              this.representativeEditable = true
              this.representativeRemovable = false

            }else if(this.assign_request_type_code == '5613'){
              //요청 구분이 Delete Agent 이라면
              this.representativeNewable = false
              this.representativeEditable = false
              this.representativeRemovable = true
            }else {
              this.representativeNewable = false
              this.representativeEditable = false
              this.representativeRemovable = false
            }

            this.flag_representative = true

            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6410'
              || res.data.receipt_status_type_code !== '4301'
              || res.data.receipt_step < 2) {
              this.$router.push('/myrequest/list')
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAssignChangeAgentInfo()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })

    },

    fnGoBefore(){
      this.$router.push({path:'/modification/assignchangeagent/step2/' + this.receipt_no})
    },

    fnGoNextStep(){
      if(this.assign_request_type_code === '5611' && this.$refs.component_representative.representatives.length === 0) {
        //Assign Agent 라면 등록요청이므로 무조건 한건은 있어야 하는데, 등록된게 없어서 다음으로 넘어갈 수 없음
        let option = {
          text : this.$t('modification.assignchangeagent.fields.msg_validate_assign')
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      } else if (this.assign_request_type_code === '5612' && this.$refs.component_representative.representatives.length === 0) {
        //Change Agent 라면 수정요청이므로 무조건 한건은 있어야 하는데, 등록된게 없어서 다음으로 넘어갈 수 없음
        let option = {
          text : this.$t('modification.assignchangeagent.fields.msg_validate_change')
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      } else if (this.assign_request_type_code === '5613' && this.$refs.component_representative.representatives.length === 0) {
        //Delete Agent 라면 삭제요청인데, 등록된 Representative 가 1건 이상이어야 함
        let option = {
          text : this.$t('modification.assignchangeagent.fields.msg_validate_fail_size')
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      } else if (this.assign_request_type_code === '5613' && this.$refs.component_representative.deleteRepresentativesCnt === 0) {
        // Delete Agent 인 경우 Representative 가 1건 이상 삭제된 건이 있어야 함
        let option = {
          text : this.$t('common.message.no_changes')
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      } else if(this.assign_request_type_code !== '5613' && this.$refs.component_representative.auto_exist_yn) {
        let option = {
          text : this.$t('component.representative.msg_auto_check'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      } else {
        requestApi({
          url: '/receivings/assign/agent/' + this.receipt_no + '/representative/submit',
          method: 'PUT',
          callback: (res) => {
            if (res.res_code === '200') {
              this.$router.push({path:'/modification/assignchangeagent/step4/' + this.receipt_no})
            }else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnGoNextStep()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    }
  }
}
</script>